import { render, staticRenderFns } from "./emailValidation.vue?vue&type=template&id=3130b309&scoped=true"
import script from "./emailValidation.vue?vue&type=script&lang=js"
export * from "./emailValidation.vue?vue&type=script&lang=js"
import style0 from "./emailValidation.vue?vue&type=style&index=0&id=3130b309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130b309",
  null
  
)

export default component.exports